<template>
  <div class="container container-fluid">

    <div v-if="showComponentData">
      <div class="row">
        <h4>Fotos carrocería</h4>
        <!-- FRENTE VEHICULO-->
        <div v-if="isFieldVisible('photo_front_panoramic_file')" class="col-md-4 mt-3">
          <div>
            <div class="form-group bordered">
              <label for="photo_front_panoramic_file" class="form-label text-left">{{ getFieldDescription('photo_front_panoramic_file') }}</label>
            </div>
            <div>
              <div>
                <div @click="openCamera('photo_front_panoramic_file')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_front_panoramic_file'"
                  :id="'photo_front_panoramic_file'"
                  style="display: none;"
                  @change="onFileChange('photo_front_panoramic_file')"
                />
              </div>
            </div>
            <div class="btn tbn-block btn-custom mt-3" v-if="photo_front_panoramic_file" @click="openImageModal(photo_front_panoramic_file)">Ver Imagen</div>
          </div>
        </div>
        <!-- CAPOT -->
        <div v-if="isFieldVisible('photo_hood_file')" class="col-md-4 mt-3">
          <div>
            <div class="form-group bordered">
              <label for="photo_hood_file" class="form-label text-left">{{ getFieldDescription('photo_hood_file') }}</label>
            </div>
            <div>
              <div>
                <div @click="openCamera('photo_hood_file')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_hood_file'"
                  :id="'photo_hood_file'"
                  style="display: none;"
                  @change="onFileChange('photo_hood_file')"
                />
              </div>
            </div>
            <div class="btn btn-block btn-custom mt-3" v-if="photo_hood_file" @click="openImageModal(photo_hood_file)">Ver Imagen</div>
          </div>
        </div>
        <!-- FOTO LATERAL IZQUIERDO -->
        <div v-if="isFieldVisible('photo_left_side_panoramic_file')" class="col-md-4 mt-3">
          <div>
            <div class="form-group bordered">
              <label for="photo_left_side_panoramic_file" class="form-label text-left">{{ getFieldDescription('photo_left_side_panoramic_file') }}</label>
            </div>
            <div>
              <div>
                <div @click="openCamera('photo_left_side_panoramic_file')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_left_side_panoramic_file'"
                  :id="'photo_left_side_panoramic_file'"
                  style="display: none;"
                  @change="onFileChange('photo_left_side_panoramic_file')"
                />
              </div>
            </div>
            <div class="btn btn-block btn-custom mt-3" v-if="photo_left_side_panoramic_file" @click="openImageModal(photo_left_side_panoramic_file)">Ver Imagen</div>
          </div>
        </div>
        <!-- FOTO LATERAL DERECHO -->
        <div v-if="isFieldVisible('photo_right_side_panoramic_file')" class="col-md-4 mt-3">
          <div>
            <div class="form-group bordered">
              <label for="photo_right_side_panoramic_file" class="form-label text-left">{{ getFieldDescription('photo_right_side_panoramic_file') }}</label>
            </div>
            <div>
              <div>
                <div @click="openCamera('photo_right_side_panoramic_file')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_right_side_panoramic_file'"
                  :id="'photo_right_side_panoramic_file'"
                  style="display: none;"
                  @change="onFileChange('photo_right_side_panoramic_file')"
                />
              </div>
            </div>
            <div class="btn btn-block btn-custom mt-3" v-if="photo_right_side_panoramic_file" @click="openImageModal(photo_right_side_panoramic_file)">Ver Imagen</div>
          </div>
        </div>
        <!-- GUARDABARROS DELANTERO IZQUIERDO -->
        <div v-if="isFieldVisible('photo_front_fender_left_file')" class="col-md-4 mt-3">
         <div>
            <div class="form-group bordered">
              <label for="photo_front_fender_left_file" class="form-label text-left">{{ getFieldDescription('photo_front_fender_left_file') }}</label>
            </div>
            <div>
              <div>
                <div @click="openCamera('photo_translate_authorization_file')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_front_fender_left_file'"
                  :id="'photo_front_fender_left_file'"
                  style="display: none;"
                  @change="onFileChange('photo_front_fender_left_file')"
                />
              </div>
            </div>
            <div class="btn btn-block btn-custom mt-3" v-if="photo_front_fender_left_file" @click="openImageModal(photo_front_fender_left_file)">Ver Imagen</div>
          </div>
        </div>
        <!-- GUARDABARROS DELANTERO DERECHO -->
        <div v-if="isFieldVisible('photo_front_fender_right_file')" class="col-md-4 mt-3">
          <div>
            <div class="form-group bordered">
              <label for="photo_front_fender_right_file" class="form-label text-left">{{ getFieldDescription('photo_front_fender_right_file') }}</label>
            </div>
            <div>
              <div>
                <div @click="openCamera('photo_front_fender_right_file')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_front_fender_right_file'"
                  :id="'photo_front_fender_right_file'"
                  style="display: none;"
                  @change="onFileChange('photo_front_fender_right_file')"
                />
              </div>
            </div>
            <div class="btn btn-block btn-custom mt-3" v-if="photo_front_fender_right_file" @click="openImageModal(photo_front_fender_right_file)">Ver Imagen</div>
          </div>
        </div>
        <!-- PUERTA CONDUCTOR -->
        <div v-if="isFieldVisible('photo_driver_side_door_file')" class="col-md-4 mt-3">
          <div>
            <div class="form-group bordered">
              <label bel for="photo_driver_side_door_file" class="form-label text-left">{{ getFieldDescription('photo_driver_side_door_file') }}</label>
            </div>
            <div>
              <div>
                <div @click="openCamera('photo_driver_side_door_file')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_driver_side_door_file'"
                  :id="'photo_driver_side_door_file'"
                  style="display: none;"
                  @change="onFileChange('photo_driver_side_door_file')"
                />
              </div>
            </div>
            <div class="btn btn-block btn-custom mt-3" v-if="photo_driver_side_door_file" @click="openImageModal(photo_driver_side_door_file)">Ver Imagen</div>
          </div>
        </div>
        <!-- PUERTA ACOMPAÑANTE -->
        <div v-if="isFieldVisible('photo_passenger_side_door_file')" class="col-md-4 mt-3">
          <div>
            <div class="form-group bordered">
              <label for="photo_passenger_side_door_file" class="form-label text-left">{{ getFieldDescription('photo_passenger_side_door_file') }}</label>
            </div>
            <div>
              <div>
                <div @click="openCamera('photo_passenger_side_door_file')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_passenger_side_door_file'"
                  :id="'photo_passenger_side_door_file'"
                  style="display: none;"
                  @change="onFileChange('photo_passenger_side_door_file')"
                />
              </div>
            </div>
            <div class="btn btn-block btn-custom mt-3" v-if="photo_passenger_side_door_file" @click="openImageModal(photo_passenger_side_door_file)">Ver Imagen</div>
          </div>
        </div>
        <!-- PUERTA TRASERA IZQ -->
        <div v-if="isFieldVisible('photo_back_left_side_door_file')" class="col-md-4 mt-3">
          <div>
            <div class="form-group bordered">
              <label for="photo_back_left_side_door_file" class="form-label text-left">{{ getFieldDescription('photo_back_left_side_door_file') }}</label>
            </div>
            <div>
              <div>
                <div @click="openCamera('photo_back_left_side_door_file')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_back_left_side_door_file'"
                  :id="'photo_back_left_side_door_file'"
                  style="display: none;"
                  @change="onFileChange('photo_back_left_side_door_file')"
                />
              </div>
            </div>
            <div class="btn btn-block btn-custom mt-3" v-if="photo_back_left_side_door_file" @click="openImageModal(photo_back_left_side_door_file)">Ver Imagen</div>
          </div>
        </div>
        <!-- PUERTA TRASERA DERECHA -->
        <div v-if="isFieldVisible('photo_back_right_side_door_file')" class="col-md-4 mt-3">
          <div>
            <div class="form-group bordered">
              <label for="photo_back_right_side_door_file" class="form-label text-left">{{ getFieldDescription('photo_back_right_side_door_file') }}</label>
            </div>
            <div>
              <div>
                <div @click="openCamera('photo_back_right_side_door_file')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_back_right_side_door_file'"
                  :id="'photo_back_right_side_door_file'"
                  style="display: none;"
                  @change="onFileChange('photo_back_right_side_door_file')"
                />
              </div>
            </div>
            <div class="btn btn-block btn-custom mt-3" v-if="photo_back_right_side_door_file" @click="openImageModal(photo_back_right_side_door_file)">Ver Imagen</div>
          </div>
        </div>
        <!-- GUARDABARROS TRASERO IZQ -->
        <div v-if="isFieldVisible('photo_back_fender_left_file')" class="col-md-4 mt-3">
          <div>
            <div class="form-group bordered">
              <label for="photo_back_fender_left_file" class="form-label text-left">{{ getFieldDescription('photo_back_fender_left_file') }}</label>
            </div>
            <div>
              <div>
                <div @click="openCamera('photo_back_fender_left_file')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_back_fender_left_file'"
                  :id="'photo_back_fender_left_file'"
                  style="display: none;"
                  @change="onFileChange('photo_back_fender_left_file')"
                />
              </div>
            </div>
            <div class="btn btn-block btn-custom mt-3" v-if="photo_back_fender_left_file" @click="openImageModal(photo_back_fender_left_file)">Ver Imagen</div>
          </div>
        </div>
        <!-- GAURDABARRO TRASERO DERECHO  -->
        <div v-if="isFieldVisible('photo_back_fender_right_file')" class="col-md-4 mt-3">
          <div>
            <div class="form-group bordered">
              <label for="photo_back_fender_right_file" class="form-label text-left">{{ getFieldDescription('photo_back_fender_right_file') }}</label>
            </div>
            <div>
              <div>
                <div @click="openCamera('photo_back_fender_right_file')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_back_fender_right_file'"
                  :id="'photo_back_fender_right_file'"
                  style="display: none;"
                  @change="onFileChange('photo_back_fender_right_file')"
                />
              </div>
            </div>
            <div class="btn btn-block btn-custom mt-3" v-if="photo_back_fender_right_file" @click="openImageModal(photo_back_fender_right_file)">Ver Imagen</div>
          </div>
        </div>
        <!-- ATRAS VEHICULO -->
        <div v-if="isFieldVisible('photo_back_panoramic_file')" class="col-md-4 mt-3">
          <div>
            <div class="form-group bordered">
              <label for="photo_back_panoramic_file" class="form-label text-left">{{ getFieldDescription('photo_back_panoramic_file') }}</label>
            </div>
            <div>
              <div>
                <div @click="openCamera('photo_back_panoramic_file')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_back_panoramic_file'"
                  :id="'photo_back_panoramic_file'"
                  style="display: none;"
                  @change="onFileChange('photo_back_panoramic_file')"
                />
              </div>
            </div>
            <div class="btn btn-block btn-custom mt-3" v-if="photo_back_panoramic_file" @click="openImageModal(photo_back_panoramic_file)">Ver Imagen</div>
          </div>
        </div>
        <!-- BAUL  -->
        <div v-if="isFieldVisible('photo_trunk_file')" class="col-md-4 mt-3">
          <div>
            <div class="form-group bordered">
              <label for="photo_trunk_file" class="form-label text-left">{{ getFieldDescription('photo_trunk_file') }}</label>
            </div>
            <div>
              <div>
                <div @click="openCamera('photo_trunk_file')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_trunk_file'"
                  :id="'photo_trunk_file'"
                  style="display: none;"
                  @change="onFileChange('photo_trunk_file')"
                />
              </div>
            </div>
            <div class="btn btn-block btn-custom mt-3" v-if="photo_trunk_file" @click="openImageModal(photo_trunk_file)">Ver Imagen</div>
          </div>
        </div>
        <!-- NUMERO DE CHASIS  -->
        <div v-if="isFieldVisible('photo_chassis_number_file')" class="col-md-4 mt-3">
          <div>
            <div class="form-group bordered">
              <label for="photo_chassis_number_file" class="form-label text-left">{{ getFieldDescription('photo_chassis_number_file') }}</label>
            </div>
            <div>
              <div>
                <div @click="openCamera('photo_chassis_number_file')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_chassis_number_file'"
                  :id="'photo_chassis_number_file'"
                  style="display: none;"
                  @change="onFileChange('photo_chassis_number_file')"
                />
              </div>
            </div>
            <div class="btn btn-block btn-custom mt-3" v-if="photo_chassis_number_file" @click="openImageModal(photo_chassis_number_file)">Ver Imagen</div>
          </div>
        </div>
      </div>
      <hr class="custom-hr mt-4" />
    </div>
  </div>
    
  <!-- MODAL -->
  <ShowImagesModal
  :modalId="'imageModalPhotoPanoramicCars'"
  :currentImage="currentImage"
  :currentImageName="currentImageName"
  />
</template>

<script>
import { ref, onMounted } from 'vue';
import ShowImagesModal from '../../modals/ShowImages';
import ImageCompressor from 'image-compressor.js'; 
import { rotateImageIfNeeded } from '../../../Utils/imageUtils';  

export default {
  name: 'FormPhotoPanaromicCArs',
  props: {
    data: Object,
  },
  components: {
    ShowImagesModal,
  },
  emits: ['formDataChanged'],
  setup(props, { emit }) {
    const dataCompany = ref(props.data.dataCompaniesForms);
    const dataFormsField = ref(props.data.dataFormsField);
    const showComponentData = ref(false);
    const currentImage = ref(null);
    const currentImageName = ref('');

    const photo_front_panoramic_file = ref(null);
    const photo_hood_file = ref(null);
    const photo_left_side_panoramic_file = ref(null);
    const photo_right_side_panoramic_file = ref(null);
    const photo_front_fender_left_file = ref(null);
    const photo_front_fender_right_file = ref(null);
    const photo_driver_side_door_file = ref(null);
    const photo_passenger_side_door_file = ref(null);
    const photo_back_left_side_door_file = ref(null);
    const photo_back_right_side_door_file = ref(null);
    const photo_back_fender_left_file = ref(null);
    const photo_back_fender_right_file = ref(null);
    const photo_back_panoramic_file = ref(null);
    const photo_trunk_file = ref(null);
    const photo_chassis_number_file = ref(null);


    const formData = ref({
      photo_front_panoramic_id: null,
      photo_hood_id: null,
      photo_left_side_panoramic_id: null,
      photo_right_side_panoramic_id: null,
      photo_front_fender_left_id: null,
      photo_front_fender_right_id: null,
      photo_driver_side_door_id: null,
      photo_passenger_side_door_id: null,
      photo_back_left_side_door_id: null,
      photo_back_right_side_door_id: null,
      photo_back_fender_left_id: null,
      photo_back_fender_right_id: null,
      photo_back_panoramic_id: null,
      photo_trunk_id: null,
      photo_chassis_number_id: null,
    });

    const cargarDatos = () => {
      try {
        showComponentData.value = (
          dataCompany.value &&
          (dataCompany.value.photo_front_panoramic_file ||
            dataCompany.value.photo_hood_file ||
            dataCompany.value.photo_left_side_panoramic_file ||
            dataCompany.value.photo_right_side_panoramic_file ||
            dataCompany.value.photo_front_fender_left_file ||
            dataCompany.value.photo_front_fender_right_file ||
            dataCompany.value.photo_driver_side_door_file ||
            dataCompany.value.photo_passenger_side_door_file ||
            dataCompany.value.photo_back_left_side_door_file ||
            dataCompany.value.photo_back_right_side_door_file ||
            dataCompany.value.photo_back_fender_left_file ||
            dataCompany.value.photo_back_fender_right_file ||
            dataCompany.value.photo_back_panoramic_file ||
            dataCompany.value.photo_trunk_file ||
            dataCompany.value.photo_chassis_number_file)
        );
      } catch (error) {
        console.error(error);
      }
    };

    const isFieldVisible = (fieldName) => {
      return dataCompany.value && dataCompany.value[fieldName] === 1;
    };

    const getFieldDescription = (fieldNameLabel) => {
      let description = fieldNameLabel;
      const dataFormsFieldsWithData = Object.values(dataFormsField.value);
 
      dataFormsFieldsWithData[0].forEach((entry) => {
        const field = entry;
 
        if (field.name === fieldNameLabel) {
          description = field.description;
        }
      });
      return description;
    };

    const openImageModal = (imageFile) => {
      currentImage.value = URL.createObjectURL(imageFile);
      currentImageName.value = imageFile.name;
      $('#imageModalPhotoPanoramicCars').modal('show');
    };

    const onFileChange = async (fieldName) => {
      const fileFields = {
        photo_front_panoramic_file: photo_front_panoramic_file,
        photo_hood_file: photo_hood_file,
        photo_left_side_panoramic_file: photo_left_side_panoramic_file,
        photo_right_side_panoramic_file: photo_right_side_panoramic_file,
        photo_front_fender_left_file: photo_front_fender_left_file,
        photo_front_fender_right_file: photo_front_fender_right_file,
        photo_driver_side_door_file: photo_driver_side_door_file,
        photo_passenger_side_door_file: photo_passenger_side_door_file,
        photo_back_left_side_door_file: photo_back_left_side_door_file,
        photo_back_right_side_door_file: photo_back_right_side_door_file,
        photo_back_fender_left_file: photo_back_fender_left_file,
        photo_back_fender_right_file: photo_back_fender_right_file,
        photo_back_panoramic_file: photo_back_panoramic_file,
        photo_trunk_file: photo_trunk_file,
        photo_chassis_number_file: photo_chassis_number_file,

      };

      const fileInput = document.getElementById(fieldName);

      try {
        const rotatedFile = await rotateImageIfNeeded(fileInput.files[0], 90);
        const compressedFile = await compressImage(rotatedFile);
        fileFields[fieldName].value = compressedFile;
        emitFieldChanged();
      } catch (error) {
        console.error('Error al comprimir la imagen:', error);
      }
    };

    const compressImage = (file) => {
      return new Promise((resolve, reject) => {
        const compressor = new ImageCompressor();
        compressor.compress(file, {
          maxWidth: 800,
          maxHeight: 600,
          quality: 1,
          mimeType: 'image/jpeg',
          success(result) {
            resolve(result);
          },
          error(error) {
            reject(error);
          },
        });
      });
    };

    const emitFieldChanged = () => {
      const formFields = {
        photo_front_panoramic_id: photo_front_panoramic_file.value,
        photo_hood_id: photo_hood_file.value,
        photo_left_side_panoramic_id: photo_left_side_panoramic_file.value,
        photo_right_side_panoramic_id: photo_right_side_panoramic_file.value,
        photo_front_fender_left_id: photo_front_fender_left_file.value,
        photo_front_fender_right_id: photo_front_fender_right_file.value,
        photo_driver_side_door_id: photo_driver_side_door_file.value,
        photo_passenger_side_door_id: photo_passenger_side_door_file.value,
        photo_back_left_side_door_id: photo_back_left_side_door_file.value,
        photo_back_right_side_door_id: photo_back_right_side_door_file.value,

        photo_back_fender_left_id: photo_back_fender_left_file.value,
        photo_back_fender_right_id: photo_back_fender_right_file.value,
        photo_back_panoramic_id: photo_back_panoramic_file.value,
        photo_trunk_id: photo_trunk_file.value,
        photo_chassis_number_id: photo_chassis_number_file.value,
      };

      const validFields = {};
      for (const [key, value] of Object.entries(formFields)) {
        if (dataCompany.value && dataCompany.value[key.replace('_id', '_file')]) {
          validFields[key] = value;
        }
      }

      formData.value = validFields;
      emit('formDataChanged', formData.value);
    };

    const openCamera = async (fieldName) => {
      try {
        const inputElement = document.getElementById(fieldName);
        inputElement.click();
      } catch (error) {
        console.error('Error al abrir la ventana de selección de archivo:', error);
      }
    };

    onMounted(cargarDatos);

    return {
      dataCompany,
      showComponentData,
      isFieldVisible,
      getFieldDescription,
      dataFormsField,
      openImageModal,
      onFileChange,
      currentImage,
      currentImageName,
      emitFieldChanged,
      formData,
      photo_front_panoramic_file,
      photo_hood_file,
      photo_left_side_panoramic_file,
      photo_right_side_panoramic_file,
      photo_front_fender_left_file,
      photo_front_fender_right_file,
      photo_driver_side_door_file,
      photo_passenger_side_door_file,
      photo_back_left_side_door_file,
      photo_back_right_side_door_file,
      photo_back_fender_left_file,
      photo_back_fender_right_file,
      photo_back_panoramic_file,
      photo_trunk_file,
      photo_chassis_number_file,
      openCamera,
    };
  },
};
</script>

